/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSupportBlockFragment, SupportBlockFragment, FullSupportBlockFragment} from '@amblique/contentful/app/contentful/fragments/support-block';

/**
 * Get a single SupportBlock by ID (base - scalars only)
 */
export const getBaseSupportBlockById = gql`
  ${BaseSupportBlockFragment}

  query GetBaseSupportBlockById($id: String!, $locale: String!, $preview: Boolean) {
    supportBlock(id: $id, locale: $locale, preview: $preview) {
      ...BaseSupportBlockFragment
    }
  }
`;

/**
 * Get a single SupportBlock by ID (standard - 1 level deep)
 */
export const getSupportBlockById = gql`
  ${SupportBlockFragment}

  query GetSupportBlockById($id: String!, $locale: String!, $preview: Boolean) {
    supportBlock(id: $id, locale: $locale, preview: $preview) {
      ...SupportBlockFragment
    }
  }
`;

/**
 * Get a single SupportBlock by ID (full - 2 levels deep)
 */
export const getFullSupportBlockById = gql`
  ${FullSupportBlockFragment}

  query GetFullSupportBlockById($id: String!, $locale: String!, $preview: Boolean) {
    supportBlock(id: $id, locale: $locale, preview: $preview) {
      ...FullSupportBlockFragment
    }
  }
`;

/**
 * Get all SupportBlock entries with pagination (base - scalars only)
 */
export const getBaseSupportBlocks = gql`
  ${BaseSupportBlockFragment}

  query GetBaseSupportBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SupportBlockOrder]
    $where: SupportBlockFilter
    $preview: Boolean
  ) {
    supportBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSupportBlockFragment
      }
    }
  }
`;

/**
 * Get all SupportBlock entries with pagination (standard - 1 level deep)
 */
export const getSupportBlocks = gql`
  ${SupportBlockFragment}

  query GetSupportBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SupportBlockOrder]
    $where: SupportBlockFilter
    $preview: Boolean
  ) {
    supportBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SupportBlockFragment
      }
    }
  }
`;

/**
 * Get all SupportBlock entries with pagination (full - 2 levels deep)
 */
export const getFullSupportBlocks = gql`
  ${FullSupportBlockFragment}

  query GetFullSupportBlocks(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SupportBlockOrder]
    $where: SupportBlockFilter
    $preview: Boolean
  ) {
    supportBlockCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSupportBlockFragment
      }
    }
  }
`;
